<button [class.disabled]="disabled()" placement="top" [mdbTooltip]="text()" (click)="clicked.emit()" class="table-icon-btn">
  <ng-content class="icon"></ng-content>
</button>
